/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getInstrumentsPrice = /* GraphQL */ `query GetInstrumentsPrice(
  $nemo: String!
  $date: String
  $start: String
  $end: String
) {
  getInstrumentsPrice(nemo: $nemo, date: $date, start: $start, end: $end)
}
` as GeneratedQuery<
  APITypes.GetInstrumentsPriceQueryVariables,
  APITypes.GetInstrumentsPriceQuery
>;
export const getOpportunities = /* GraphQL */ `query GetOpportunities($quantity: String) {
  getOpportunities(quantity: $quantity)
}
` as GeneratedQuery<
  APITypes.GetOpportunitiesQueryVariables,
  APITypes.GetOpportunitiesQuery
>;
export const info = /* GraphQL */ `query Info($cognitoId: ID!) {
  info(cognitoId: $cognitoId) {
    id
    cognitoId
    identityId
    salesforceId
    givenName
    familyName
    email
    phone
    birth
    dni
    signUpCountry
    originCountry
    residenceCountry
    city
    address
    job
    liveInUSA
    isPEP
    riskProfile
    riskPoints
    knowledgeProfile
    knowledgePoints
    userProfileSignature
    isKycApproved
    acceptTerms
    userAcceptTermsSignature
    customerStatus
    customerType
    customerCategory
    kycNextStep
    sf_Broker__c
    subaccounts {
      total_deposit_clp
      total_ransom_pen
      total_deposit_usd
      total_ransom_clp
      total_ransom_usd
      total_deposit_pen
      name
      currency
      __typename
    }
    wasIdFileUploaded
    userIdFileSignature
    frontSideIdFilePath
    backSideIdFilePath
    wasAddressFileUploaded
    userAddressFileSignature
    addressFilePath
    wasCardFileUploaded
    userCardFileSignature
    cardFilePath
    wasLivenessFileUploaded
    confirmPhone
    wasPhoneValidate
    wasCreatedInMarketingCloud
    wasCreatedInSalesforce
    needKyc
    require_metamap_upload
    utmSource
    utmMedium
    utmCampaign
    utmId
    createdAt
    updatedAt
    validatePersonalInfo
    __typename
  }
}
` as GeneratedQuery<APITypes.InfoQueryVariables, APITypes.InfoQuery>;
export const getSubaccountsAndTransactions = /* GraphQL */ `query GetSubaccountsAndTransactions($cognitoId: ID!) {
  getSubaccountsAndTransactions(cognitoId: $cognitoId)
}
` as GeneratedQuery<
  APITypes.GetSubaccountsAndTransactionsQueryVariables,
  APITypes.GetSubaccountsAndTransactionsQuery
>;
export const getUserBroker = /* GraphQL */ `query GetUserBroker($cognitoId: ID!) {
  getUserBroker(cognitoId: $cognitoId)
}
` as GeneratedQuery<
  APITypes.GetUserBrokerQueryVariables,
  APITypes.GetUserBrokerQuery
>;
export const getTokenNuvei = /* GraphQL */ `query GetTokenNuvei(
  $cognitoId: ID!
  $amount: String!
  $currency: String!
  $country: String!
) {
  getTokenNuvei(
    cognitoId: $cognitoId
    amount: $amount
    currency: $currency
    country: $country
  )
}
` as GeneratedQuery<
  APITypes.GetTokenNuveiQueryVariables,
  APITypes.GetTokenNuveiQuery
>;
export const getUserExecutivesTeam = /* GraphQL */ `query GetUserExecutivesTeam($cognitoId: ID!) {
  getUserExecutivesTeam(cognitoId: $cognitoId)
}
` as GeneratedQuery<
  APITypes.GetUserExecutivesTeamQueryVariables,
  APITypes.GetUserExecutivesTeamQuery
>;
export const getRiskProfileQuestions = /* GraphQL */ `query GetRiskProfileQuestions {
  getRiskProfileQuestions
}
` as GeneratedQuery<
  APITypes.GetRiskProfileQuestionsQueryVariables,
  APITypes.GetRiskProfileQuestionsQuery
>;
export const getKnowledgeProfileQuestions = /* GraphQL */ `query GetKnowledgeProfileQuestions {
  getKnowledgeProfileQuestions
}
` as GeneratedQuery<
  APITypes.GetKnowledgeProfileQuestionsQueryVariables,
  APITypes.GetKnowledgeProfileQuestionsQuery
>;
export const getUser = /* GraphQL */ `query GetUser($id: ID!) {
  getUser(id: $id) {
    id
    cognitoId
    identityId
    salesforceId
    givenName
    familyName
    email
    phone
    birth
    dni
    signUpCountry
    originCountry
    residenceCountry
    city
    address
    job
    liveInUSA
    isPEP
    riskProfile
    riskPoints
    knowledgeProfile
    knowledgePoints
    userProfileSignature
    isKycApproved
    acceptTerms
    userAcceptTermsSignature
    customerStatus
    customerType
    customerCategory
    kycNextStep
    sf_Broker__c
    subaccounts {
      total_deposit_clp
      total_ransom_pen
      total_deposit_usd
      total_ransom_clp
      total_ransom_usd
      total_deposit_pen
      name
      currency
      __typename
    }
    wasIdFileUploaded
    userIdFileSignature
    frontSideIdFilePath
    backSideIdFilePath
    wasAddressFileUploaded
    userAddressFileSignature
    addressFilePath
    wasCardFileUploaded
    userCardFileSignature
    cardFilePath
    wasLivenessFileUploaded
    confirmPhone
    wasPhoneValidate
    wasCreatedInMarketingCloud
    wasCreatedInSalesforce
    needKyc
    require_metamap_upload
    utmSource
    utmMedium
    utmCampaign
    utmId
    createdAt
    updatedAt
    validatePersonalInfo
    __typename
  }
}
` as GeneratedQuery<APITypes.GetUserQueryVariables, APITypes.GetUserQuery>;
export const listUsers = /* GraphQL */ `query ListUsers(
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
) {
  listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      cognitoId
      identityId
      salesforceId
      givenName
      familyName
      email
      phone
      birth
      dni
      signUpCountry
      originCountry
      residenceCountry
      city
      address
      job
      liveInUSA
      isPEP
      riskProfile
      riskPoints
      knowledgeProfile
      knowledgePoints
      userProfileSignature
      isKycApproved
      acceptTerms
      userAcceptTermsSignature
      customerStatus
      customerType
      customerCategory
      kycNextStep
      sf_Broker__c
      wasIdFileUploaded
      userIdFileSignature
      frontSideIdFilePath
      backSideIdFilePath
      wasAddressFileUploaded
      userAddressFileSignature
      addressFilePath
      wasCardFileUploaded
      userCardFileSignature
      cardFilePath
      wasLivenessFileUploaded
      confirmPhone
      wasPhoneValidate
      wasCreatedInMarketingCloud
      wasCreatedInSalesforce
      needKyc
      require_metamap_upload
      utmSource
      utmMedium
      utmCampaign
      utmId
      createdAt
      updatedAt
      validatePersonalInfo
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ListUsersQueryVariables, APITypes.ListUsersQuery>;
